/**
 * @generated SignedSource<<65c7ea2d719d072cb94fc604ff5d0e76>>
 * @relayHash 5480d6d422569c20ba04eadafd93552c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5480d6d422569c20ba04eadafd93552c

import { ConcreteRequest } from 'relay-runtime';
export type useChPointOfCareSpecialtyQuery$variables = {
  searchText: string;
};
export type useChPointOfCareSpecialtyQuery$data = {
  readonly chPointOfCareSpecialties: {
    readonly nodes: ReadonlyArray<{
      readonly careProviderSpecialty: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly specialtyTranslations: ReadonlyArray<{
        readonly language: string;
        readonly name: string;
      }>;
      readonly synonym: string | null;
      readonly word: string;
    }> | null;
  } | null;
};
export type useChPointOfCareSpecialtyQuery = {
  response: useChPointOfCareSpecialtyQuery$data;
  variables: useChPointOfCareSpecialtyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchText"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contains",
    "variableName": "searchText"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": "chPointOfCareSpecialties",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 50
      },
      {
        "kind": "Literal",
        "name": "order",
        "value": [
          {
            "word": "ASC"
          }
        ]
      },
      {
        "fields": [
          {
            "items": [
              {
                "fields": [
                  {
                    "fields": (v1/*:: as any*/),
                    "kind": "ObjectValue",
                    "name": "word"
                  }
                ],
                "kind": "ObjectValue",
                "name": "or.0"
              },
              {
                "fields": [
                  {
                    "fields": (v1/*:: as any*/),
                    "kind": "ObjectValue",
                    "name": "synonym"
                  }
                ],
                "kind": "ObjectValue",
                "name": "or.1"
              },
              {
                "fields": [
                  {
                    "fields": [
                      {
                        "fields": [
                          {
                            "fields": (v1/*:: as any*/),
                            "kind": "ObjectValue",
                            "name": "name"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "some"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "specialtyTranslations"
                  }
                ],
                "kind": "ObjectValue",
                "name": "or.2"
              }
            ],
            "kind": "ListValue",
            "name": "or"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "PointOfCareSpecialtyConnection",
    "kind": "LinkedField",
    "name": "ch_pointOfCareSpecialties",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PointOfCareSpecialty",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "word",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "synonym",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PointOfCareSpecialtyTranslation",
            "kind": "LinkedField",
            "name": "specialtyTranslations",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Specialty",
            "kind": "LinkedField",
            "name": "careProviderSpecialty",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChPointOfCareSpecialtyQuery",
    "selections": (v4/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChPointOfCareSpecialtyQuery",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "id": "5480d6d422569c20ba04eadafd93552c",
    "metadata": {},
    "name": "useChPointOfCareSpecialtyQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d9d15c304db6c440c8e0dd368eb2857f";

export default node;
